import type { CardRow } from '@littlebird/action-cards-view';

export type CardStatus = CardRow['status'];

// The card has run, here or in the destination app
const DONE_STATUSES: ReadonlySet<CardStatus> = new Set([
  'completed',
  'completed_externally',
]);

export const isDoneStatus = (status: CardStatus | undefined): boolean =>
  status !== undefined && DONE_STATUSES.has(status);
